<script setup lang="ts">
import { computed, ref } from 'vue';
import { FetchTicketResponsePriority } from 'src/api/models';
import { useDropdownState } from 'src/composables/useDropdownState';
import SharedDropdown from 'src/components/shared/SharedDropdown.vue';
import { PRIORITY_OPTIONS } from './ticket-display-data';
import 'src/assets/ticket-edit-property.css';

const props = defineProps<{
  priority?: FetchTicketResponsePriority;
}>();

const emit = defineEmits<{
  'update:priority': [value: FetchTicketResponsePriority];
}>();

const rootEl = ref<HTMLElement>();
const { isOpen, toggle, close } = useDropdownState(rootEl);

const currentPriority = computed(() => PRIORITY_OPTIONS.find((p) => p.value === props.priority) ?? PRIORITY_OPTIONS[1]);

function selectPriority(p: (typeof PRIORITY_OPTIONS)[number]): void {
  emit('update:priority', p.value);
  close();
}
</script>

<template>
  <div ref="rootEl" class="relative">
    <div class="prop-row" @click="toggle">
      <span class="prop-label">Priority</span>
      <span :class="['inline-flex items-center gap-1 text-s font-semibold', currentPriority.color]">
        <i :class="['pi', currentPriority.icon]" style="font-size: 11px" />
        {{ currentPriority.label }}
        <i class="pi pi-chevron-down prop-chevron" />
      </span>
    </div>
    <SharedDropdown
      :open="isOpen"
      :items="PRIORITY_OPTIONS" :active-id="priority"
      id-key="value" label-key="label"
      max-height="300px" @select="selectPriority"
    >
      <template #item="{ item }">
        <i :class="['pi', item.icon, item.color, 'mr-2']" style="font-size: 11px" />
        {{ item.label }}
      </template>
    </SharedDropdown>
  </div>
</template>
